import React from 'react'

interface Props {
  isLoading: boolean
  variant?: 'ConversationMessage' | 'OfferMessage'
}

const MessageLoader = ({ isLoading, variant = 'ConversationMessage' }: Props): JSX.Element => {
  if (!isLoading) {
    return <></>
  }

  const backgroundColor = variant === 'ConversationMessage' ? 'bg-groupBlue' : 'bg-white'
  return (
    <div className={`flex gap-1 mt-6 justify-center ${variant === 'ConversationMessage' ? '' : 'mb-5'}`}>
      <div className={`h-4 w-4 ${backgroundColor} rounded-4 animate-bounce [animation-delay:-0.3s]`}></div>
      <div className={`h-4 w-4 ${backgroundColor} rounded-4 animate-bounce [animation-delay:-0.15s]`}></div>
      <div className={`h-4 w-4 ${backgroundColor} rounded-4 animate-bounce`}></div>
    </div>
  )
}

export default MessageLoader
